import { relationNodes } from "@/mocks/homeData";

export default function RelationSection() {
  return (
    <section id="relations" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <p className="text-xs font-medium uppercase tracking-widest text-accent-700">关联人物网络</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              别只盯一个人，看清他在网里怎么动
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              一次热曝常常牵动多方：被点名对象、涉事机构、首曝来源、前关联方与跟进媒体。把这些人之间的同框与交集摆上桌面，判断才更稳。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                "用「角色标签」而非真名指代，便于追更与复盘",
                "同框、交集、回应关系逐条备注，信息可回查",
                "关系随时间线更新，热度转冷后仍有完整留存",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs text-foreground-950">
                    <i className="ri-check-line" />
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:col-span-7">
            {relationNodes.map((node) => (
              <article
                key={node.name}
                className="group rounded-lg border border-background-200/70 bg-background-50 p-4 text-center transition-colors hover:border-primary-200 md:p-5"
              >
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 font-heading text-lg font-bold text-primary-700 ring-2 ring-accent-500/30 transition-colors group-hover:ring-primary-400 md:h-14 md:w-14">
                  {node.letter}
                </span>
                <p className="mt-3 text-xs font-medium uppercase tracking-wider text-accent-700">{node.role}</p>
                <p className="mt-1 text-sm font-semibold text-foreground-900">{node.name}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{node.note}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}